import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'titleTextbgColor'
})(({ theme, titleTextbgColor }) => ({
  "& .MuiDialogContent-root": {
    padding: 0,
    border: 'none',

  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialogTitle-root": {
    background: titleTextbgColor || "#0086FF",
    color: "#ffffff",
    padding: "8px 16px",
  },
  "& .MuiIconButton-root": {
    padding: "4px",
  },
  "& .MuiDialogActions-root": {
    padding: "15px 27px 10px 25px!important",
    display: "flex",
    justifyContent: "flex-end!important",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontSize: '16px' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 6,
            color: "#ffffff",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
export default function CustomizedDialogs(props) {
  const { open, onClose, titleText = "", children, mw = "auto", padding = '24px', zIndex = '1300', width = "auto", height = "auto", bgColor = '#FFFFFF', titleTextbgColor = "#0086FF", shouldBlockEscapeKey = false, contentOverflowY = '' } = props;

  const handleKeyDown = (event) => {
    if (event?.key === 'Escape') {
      onClose()
    }
  }
  return (
    <div>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason === "escapeKeyDown") {
            event.preventDefault();
            return;
          }
          onClose();
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        titleTextbgColor={titleTextbgColor}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: 'none !important',
          },
          '& .MuiDialogTitle-root ': {
            padding: '10px 16px 10px 16px'
          },
          '& .MuiDialog-paper': { width: width, maxWidth: "100%", height: height, borderRadius: '8px', minWidth: mw, zIndex: zIndex, overflow: 'visible', backgroundColor: bgColor },
          '& .MuiDialogContent-root': {
            padding: `${padding} !important`,
            overflow: `${contentOverflowY === '' ? height === 'auto' ? "visible" : 'auto' : contentOverflowY} !important`,
          }
        }}
        onKeyDown={handleKeyDown}
      >
        {titleText &&
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={onClose}
            style={{
              borderTopLeftRadius: '6px', borderTopRightRadius: '6px'
            }}
          >
            {titleText}
          </BootstrapDialogTitle>
        }
        <DialogContent sx={{
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px',

        }} dividers >{children}</DialogContent>
      </BootstrapDialog>
    </div>
  );
}